import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployeeCanDirective } from 'pm-src/app/directives/employee-can.directive';
import { HeaderModule } from '../header/header.module';
import { OrderItemStateComponent } from './order-item-state/order-item-state.component';
import { IonicModule } from '@ionic/angular';
import { OrderItemComponent } from 'pm-src/app/modules/markup-inspection/order-item/order-item.component';
import { OrderReplacementItemComponent } from 'pm-src/app/modules/markup-inspection/order-replacement-item/order-replacement-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared';

@NgModule({
    declarations: [
        EmployeeCanDirective,
        OrderItemStateComponent,
        OrderItemComponent,
        OrderReplacementItemComponent,
    ],
    imports: [TranslateModule, CommonModule, HeaderModule, IonicModule, SharedModule],
    exports: [
        HeaderModule,
        EmployeeCanDirective,
        OrderItemStateComponent,
        OrderItemComponent,
        OrderReplacementItemComponent,
    ],
})
export class AppSharedModule {}
